'use strict';

import jQuery from 'jquery';
import Core from './../Core/Core';

(function($) {

  // When a show is clicked, set the autoplay cookie to true
  $('.search-results').on(
    'click',
    '.episode-result a',
    function (e) {

      // Set the URL for the clicked element
      var pathname = $(this).parents('.search-item').find('.video-item-watchable').attr('href').replace(/^.*\/\/[^\/]+/, '');

      // Set the autoplay cookie for the client
      Core.AutoPlayCookie.addAutoplayURL(pathname);
    }
  );

  // Deal with loading more results.
  $('.search-results').on('click', '.load-more-btn', function(e) {
    var $this = $(this), data = {};

    $this.attr('disabled', 'disabled');
    data['offset'] = $('#offset').val();
    data['s'] = $('#s').val();

    $.ajax({
      url: '/search-more',
      data: data
    }).then(function(data) {
      $('#offset').val(parseInt($('#offset').val()) + 10);
      $('.search-results').append(data);
      $(".search-item").removeClass('faded');
      $this.parent().hide();
    }).catch(function() {
      alert('Error getting more results!');
      $this.removeAttr('disabled');
    });

    e.preventDefault();
  });
})(jQuery);

export default {}